import React, { useState } from "react";
import { useSelector } from "react-redux";
import Breadcrumbs from "../../components/others/BreadCrumbs";
import GlobalStyles from "../../global/GlobalStyles";
import ProfileDetailsCard from "../../components/others/ProfileDetailsCard";
import BigLoader from "../../components/loaders/BigLoader";

const breadcrumbItems = [
  { name: "Dashboard", path: "/admin/dashboard" },
  { name: "Profile", path: "/admin/dashboard/profile" },
];

const ProfilePage = () => {
  const user = useSelector((state) => state.user.profile);
  const [loading, setLoading] = useState(false);

  return (
    <div className={GlobalStyles.dashbooardPageContainer}>
      <div className={GlobalStyles.dashbooardPageWrap}>
        <div className={GlobalStyles.seperator}>
          <Breadcrumbs items={breadcrumbItems} />
        </div>
        {loading && (
          <div className="w-full flex justify-center py-40">
            <BigLoader />
          </div>
        )}
        {user && !loading && (
          <div className="w-full flex justify-center">
            <div className="w-full md:w-2/3 lg:w-1/2">
              <ProfileDetailsCard
                user={user}
                setLoading={setLoading}
                personal={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
